__turbopack_context__.v({
  "antCardBody": "TRwhDG_antCardBody",
  "cardFixed": "TRwhDG_cardFixed",
  "cardLeft": "TRwhDG_cardLeft",
  "cardRight": "TRwhDG_cardRight",
  "cards": "TRwhDG_cards",
  "centerImage": "TRwhDG_centerImage",
  "compareSection": "TRwhDG_compareSection",
  "content": "TRwhDG_content",
  "headContact": "TRwhDG_headContact",
  "imageWrapper": "TRwhDG_imageWrapper",
  "left1": "TRwhDG_left1",
  "left2": "TRwhDG_left2",
  "line": "TRwhDG_line",
  "lineMobile": "TRwhDG_lineMobile",
  "netralcolor": "TRwhDG_netralcolor",
  "p": "TRwhDG_p",
  "page-body-wrap": "TRwhDG_page-body-wrap",
  "pagehero": "TRwhDG_pagehero",
  "paragraph": "TRwhDG_paragraph",
  "paragraph-content": "TRwhDG_paragraph-content",
  "paragraph1": "TRwhDG_paragraph1",
  "phonecontent": "TRwhDG_phonecontent",
  "right1": "TRwhDG_right1",
  "right2": "TRwhDG_right2",
  "store": "TRwhDG_store",
  "t": "TRwhDG_t",
  "title": "TRwhDG_title",
  "title1": "TRwhDG_title1",
  "wrap-container": "TRwhDG_wrap-container",
  "wrap-content": "TRwhDG_wrap-content",
});
